import { useMutation } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'

export const useRemoveCommissionMutation = (refetchCommissions: () => void) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: removeCommissionMutation, isPending: removeCommissionIsLoading } = useMutation({
		mutationFn: (id: number) => {
			// TODO: change to apiRoutes
			return axiosPrivate.delete(`/settings/commission-rates/${id}/`)
		},
		onSuccess: () => {
			refetchCommissions()

			useToast({
				type: 'success',
				message: t('Commission removed')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		}
	})

	return {
		removeCommissionMutation,
		removeCommissionIsLoading
	}
}
